import type {
  InventoryStatus,
  InventoryResultArgs
} from '@this/src/api/domestic_air/same_day_inventory_checks_api';

// 依頼可否・モーダル分岐を決める「最も重い結果」の優先度。
// 数値が大きいほど重い（unavailable が最重）。
const STATUS_PRIORITY: Record<InventoryStatus, number> = {
  unavailable: 6,
  ticket_type_changed: 5,
  price_increased: 4,
  operator_check: 3,
  price_decreased: 2,
  available: 1,
  // 確定後（在庫確認モーダル分岐では通常出現しないが、availableと同等に扱う）
  ticket_type_changed_confirmed: 1
};

// 在庫確認結果一覧のうち、最も重いステータスを返す。
// 結果が空の場合は available 扱い（＝そのまま決済続行）。
export const worstInventoryStatus = (results: InventoryResultArgs[]): InventoryStatus => {
  return results.reduce<InventoryStatus>((worst, result) => {
    return STATUS_PRIORITY[result.inventoryStatus] > STATUS_PRIORITY[worst] ? result.inventoryStatus : worst;
  }, 'available');
};
